import React from 'react';
import './IOSErrorModal.css';

function IOSErrorModal({ errorType, onResume }) {
  const isPauseError = errorType === 'pause';
  const isWrongSongError = errorType === 'wrongSong';

  return (
    <div className="ios-error-modal-overlay">
      <div className="ios-error-modal-container">
        <div className="ios-error-modal-content">
          {isPauseError && (
            <>
              <h2>Playback Paused</h2>
              <div className="error-icon">⏸️</div>
              <div className="error-instructions">
                <p className="error-main">
                  You paused the playback.
                </p>
                <p className="error-sub">
                  To continue rating this song, please click the button below to resume playback.
                </p>
              </div>
            </>
          )}

          {isWrongSongError && (
            <>
              <h2>Wrong Song Playing</h2>
              <div className="error-icon">⚠️</div>
              <div className="error-instructions">
                <p className="error-main">
                  You're playing a different song.
                </p>
                <p className="error-sub">
                  To continue rating, click the button below to play the correct song.
                </p>
              </div>
            </>
          )}

          <button
            className="ios-error-resume-button"
            onClick={onResume}
          >
            Resume Playback
          </button>

          <p className="error-note">
            This will play the correct song and continue the timer.
          </p>
        </div>
      </div>
    </div>
  );
}

export default IOSErrorModal;
